import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import { ExpandMore, Lock, Logout, Person } from "@mui/icons-material";
import { useAuth } from "@sal/authentication.react";
import { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DENY_PERMISSION, getUsername } from "../../utilities";
import { useMsal } from "@azure/msal-react";
import { usePortalFramework } from "../../PortalFramework";
export function AuthenticatedUserMenu({ permissions, }) {
    var _a;
    const portalFramework = usePortalFramework();
    // PERMISSIONS
    const auth = useAuth();
    const hasChangePasswordPermission = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.changePassword) !== null && _a !== void 0 ? _a : DENY_PERMISSION;
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const handleClose = useCallback(() => setOpen(false), []);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { ref: anchorRef, display: "flex", alignItems: "center", gap: 2, sx: {
                    cursor: "pointer",
                }, onClick: () => setOpen((x) => !x), children: [_jsx(Person, { color: "inherit" }), _jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(Typography, { display: "inline-flex", fontWeight: 600, paddingTop: 0.5, lineHeight: 1, sx: {
                                    color: "inherit",
                                    margin: 0,
                                }, children: getUsername(auth) }), _jsx(ExpandMore, { color: "inherit" })] })] }), _jsxs(Menu, { anchorEl: anchorRef.current, open: open, onClose: handleClose, onClick: handleClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "center",
                }, children: [hasChangePasswordPermission(auth) && (_jsxs(MenuItem, { onClick: () => navigate({ pathname: "/ChangePassword" }), children: [_jsx(ListItemIcon, { children: _jsx(Lock, { fontSize: "small", color: "inherit" }) }), _jsx("span", { children: "Change Password" })] })), _jsxs(MenuItem, { onClick: () => {
                            const callback = () => {
                                var _a, _b;
                                if ((_b = (_a = portalFramework.settings) === null || _a === void 0 ? void 0 : _a.microsoftSsoSettings) === null || _b === void 0 ? void 0 : _b.enableSso) {
                                    const logoutRequest = {
                                        postLogoutRedirectUri: "/#/Login",
                                    };
                                    instance.logoutRedirect(logoutRequest);
                                }
                                else {
                                    navigate({ pathname: "/" });
                                }
                            };
                            auth.logout(callback);
                        }, children: [_jsx(ListItemIcon, { children: _jsx(Logout, { fontSize: "small", color: "inherit" }) }), _jsx("span", { children: "Logout" })] })] })] }));
}
